import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import provinces from "../../util/provinces";
import FieldSelect from "../common/FieldSelect";

class FieldProvince extends Component {

    /**
     * Render the component.
     *
     * @returns {*} - A select field component, specialized for Canadian provinces.
     */
    render() {

        return(
            <FieldSelect id={this.props.id} label={this.props.label} labelClass={this.props.labelClass} fieldClass={this.props.fieldClass}
                         fieldColumns={this.props.fieldColumns} labelColumns={this.props.labelColumns} handleChange={this.props.handleChange}
                         disabled={this.props.disabled} model={this.props.model} parent={this.props.parent} value={this.props.value}
                         required={this.props.required} leaseApplicationPage={this.props.leaseApplicationPage}>

                <option value="">Select a province...</option>

                <React.Fragment>
                    {Object.keys(provinces).map(key => {
                        return (
                            <FormattedMessage key={key} id={"province." + key}>
                                {(province) => <option key={key} value={key}>{province}</option>}
                            </FormattedMessage>
                        )
                    })}
                </React.Fragment>
            </FieldSelect>
        )
    };
}

FieldProvince.defaultProps = {
    labelColumns: '3',
    fieldColumns: '9',
    disabled: false
};

export default FieldProvince;
